// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/ao_half_depth.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'ao_half_depthPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform highp sampler2D depthSampler;
uniform mat4 invertedProjectionMatrix;
float linearizeDepth(float z) {
vec4 p = invertedProjectionMatrix * vec4(vUV * 2.0 - 1.0, z * 2.0 - 1.0, 1.0);
return p.z / p.w;
}
float averageDepth(vec4 depth) {
return dot(depth, vec4(0.25));
}
float minDepth(vec4 depth) {
return min(depth.x, min(depth.y, min(depth.z, depth.w)));
}
float maxDepth(vec4 depth) {
return max(depth.x, max(depth.y, max(depth.z, depth.w)));
}
float checkerboard(vec2 pos) {
return mod(pos.x + mod(pos.y, 2.0), 2.0);
}
float checkeredDepth(vec4 depth) {
return mix(minDepth(depth), maxDepth(depth), checkerboard(gl_FragCoord.xy));
}
void main(void)
{
vec4 depth;
depth.x = texelFetch(depthSampler, ivec2(2.0 * gl_FragCoord.xy) + ivec2(0, 0), 0).r;
depth.y = texelFetch(depthSampler, ivec2(2.0 * gl_FragCoord.xy) + ivec2(1, 0), 0).r;
depth.z = texelFetch(depthSampler, ivec2(2.0 * gl_FragCoord.xy) + ivec2(1, 1), 0).r;
depth.w = texelFetch(depthSampler, ivec2(2.0 * gl_FragCoord.xy) + ivec2(0, 1), 0).r;
float z;
z = minDepth(depth);
if (z == 1.0 || z == 0.0) {
gl_FragColor = vec4(-1.0, 0.0, 0.0, 1.0);
} else {
gl_FragColor = vec4(linearizeDepth(z), 0, 0, 1);
}
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ao_half_depthPixelShader = { name, shader };
//# sourceMappingURL=ao_half_depth.fragment.js.map